import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import moment from 'moment'
import vuetify from './plugins/vuetify'
require('@/assets/css/style.css')

Vue.config.productionTip = false

Vue.prototype.moment = moment

const baseURL = window.location.hostname === 'localhost'
  ? 'http://thedigestapp-backend.test'
  : 'https://api.trueheroesfilms.org'

Vue.prototype.baseURL = baseURL

Vue.prototype.$http = axios
Vue.prototype.$http.defaults.baseURL = `${baseURL}/api`
Vue.prototype.$http.defaults.headers.post['Content-Type'] = 'application/json'

new Vue({
  router,
  store,
  vuetify,
  created () {
    const userString = localStorage.getItem('user')
    if (userString) {
      const userData = JSON.parse(userString)
      this.$store.commit('SET_USER_DATA', userData)
    }
    axios.interceptors.response.use(
      response => response,
      error => {
        if (error.response.status === 401) {
          this.$router.push('/login')
          this.$store.commit('CLEAR_USER_DATA')
        }
        return Promise.reject(error)
      }
    )
  },
  render: h => h(App)
}).$mount('#app')

// Capitalize first letter
Vue.filter('capitalize', value => {
  if (!value) return ''
  value = value.toString()
  return value.charAt(0).toUpperCase()
})

Vue.filter('capitalizeName', value => {
  if (!value) return ''
  const name = value.toString().split(' ')
  return name.length > 1 ? name[0].charAt(0).toUpperCase() + name[1].charAt(0).toUpperCase() : name[0].charAt(0).toUpperCase()
})

// Full Name Filter
Vue.filter('fullName', value => {
  if (!value) return ''

  const firstName = value.first_name || ''
  const lastName = value.last_name || ''

  return firstName + ' ' + lastName
  // return `${value.first_name} ${value.last_name}`
})
